/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, formula, price, cost, fee_percent, discount_percent, description, brand, image_name },
} = checkout;

const validations = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg),
  [formula.name]: Yup.string().required(formula.errorMsg),
  [price.name]: Yup.number().required(price.errorMsg).min(0, price.invalidMsg),
  [cost.name]: Yup.number().required(cost.errorMsg).min(0, price.invalidMsg),
  [fee_percent.name]: Yup.number().required(fee_percent.errorMsg).min(0, fee_percent.invalidMsg),
  [discount_percent.name]: Yup.number().required(discount_percent.errorMsg).min(0, discount_percent.invalidMsg),
  [image_name.name]: Yup.string().required(image_name.errorMsg),
});

export default validations;
